angular.module('mainContentArea', []);
